/* eslint-disable import/prefer-default-export */
export const reducerName = `paymentForm`;
export const createReducerDotPathName = combineName =>
  `${combineName}.${reducerName}`;
export const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/reducers/paymentForm/naming.js